import React from 'react'
import { TimelineSpan } from '../domain/TimelineSpan'
import Link from '../helper/link'
import Milliseconds from '../helper/milliseconds'

type Props = {
    type: string
    spans?: TimelineSpan[]
    routes?: {
        timelineRoute: string
    }
}

export const BottleneckRelatedSpans: React.FunctionComponent<Props> = ({ routes, spans, type }) => {
    if (!routes) {
        return null
    }

    const relatedSpans: TimelineSpan[] = spans ? spans.filter(span => span.bottlenecks?.includes(type)) : []

    if (relatedSpans.length === 0) {
        return null
    }

    return (
        <>
            <h4 className="tw-font-size-16 tw-mt-24">Related Timeline Spans</h4>
            <table className="table table-striped table-bordered table-condensed">
                <tbody>
                    {relatedSpans
                        .sort((a, b) => b.wt - a.wt)
                        .slice(0, 10)
                        .map(span => (
                            <tr key={span.id}>
                                <td>
                                    <Link route={routes.timelineRoute} params={{ span: span.id }}>
                                        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
                                            <div>{span.name}</div>
                                            <div>
                                                <Milliseconds value={span.wt} />
                                            </div>
                                        </div>
                                    </Link>
                                </td>
                            </tr>
                        ))}
                </tbody>
                {relatedSpans.length > 10 ? <p>...and {relatedSpans.length - 10} more</p> : null}
            </table>
        </>
    )
}
